import { Injectable } from '@angular/core';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';
import { environment } from '../../../environments/environment';
import DOMPurify from 'dompurify';

@Injectable({
  providedIn: 'root'
})
export class CustomIconService {
  iconsPath = `${environment.cvaUI_url}/assets/icons`
  icons = [
    {
      name: 'dashboard-icon',
      fileName: 'dashboard.svg'
    },
    {
      name: 'activity-icon',
      fileName: 'activity.svg'
    },
    {
      name: 'setting-icon',
      fileName: 'setting.svg'
    },
    {
      name: 'calendar-icon',
      fileName: 'calendar.svg'
    },
    {
      name: 'move_icon',
      fileName: 'move_icon.svg'
    }
  ]
  constructor(private readonly  matIconRegistry: MatIconRegistry, private readonly  domSanitizer: DomSanitizer) { }

  registerCustomIcon() {
    this.icons.forEach((icon) => {
      const sanitizedPath = DOMPurify.sanitize(`${this.iconsPath}/${icon.fileName}`)
      this.matIconRegistry.addSvgIcon(
        icon.name, // the name you want to give to your icon
        this.domSanitizer.bypassSecurityTrustResourceUrl(sanitizedPath) //NOSONAR 
      );
    })
  }
}
